module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/07-a53505dce4a37474118123fbc48a9344.jpg";